angular.module('admin.homepage', [
  'admin.homepage.index',
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/homepage/index.js